import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logofilter from "assets/images/ugifts/dummyBanner/filter.png"
import logosort from "assets/images/ugifts/dummyBanner/sort.png"

import sortAsc from "assets/images/ugifts/icons/sort/sort_asc.png"
import sortDesc from "assets/images/ugifts/icons/sort/sort_desc.png"
import sortHigh from "assets/images/ugifts/icons/sort/sort_high.png"
import sortLow from "assets/images/ugifts/icons/sort/sort_low.png"
import sortLatest from "assets/images/ugifts/icons/sort/sort_latest.png"
import sortPopularity from "assets/images/ugifts/icons/sort/sort_popularity.png"

import filterBrands from "assets/images/ugifts/icons/filter/filter_brands.png"
import filterCategories from "assets/images/ugifts/icons/filter/filter_categories.png"
import filterPrice from "assets/images/ugifts/icons/filter/filter_price.png"
import filterPromo from "assets/images/ugifts/icons/filter/filter_promo.png"
import filterRecommeded from "assets/images/ugifts/icons/filter/filter_recommended.png"

import { Button } from "@material-ui/core"
import { propTypes } from "react-barcode"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Products = props => {
  const query = useQuery()
  const history = useHistory()

  const sortData = [
    {
      icon: sortPopularity,
      name: props.t("Popularity"),
      option: "POPULAR",
    },
    {
      icon: sortLatest,
      name: props.t("Latest"),
      option: "NEW",
    },
    {
      icon: sortAsc,
      name: props.t("A to Z"),
      option: "ASC",
    },
    {
      icon: sortDesc,
      name: props.t("Z to A"),
      option: "DESC",
    },
    {
      icon: sortHigh,
      name: props.t("Price (High to Low)"),
      option: "HIGH",
    },
    {
      icon: sortLow,
      name: props.t("Price (Low to High)"),
      option: "LOW",
    },
  ]

  const priceFilterData = [
    {
      name: props.t("Below 100"),
      option: "below100",
      priceStart: 0,
      priceEnd: 100,
    },
    {
      name: props.t("Below 80"),
      option: "below80",
      priceStart: 0,
      priceEnd: 80,
    },
    {
      name: props.t("Below 50"),
      option: "below50",
      priceStart: 0,
      priceEnd: 50,
    },
    {
      name: props.t("Below 20"),
      option: "below20",
      priceStart: 0,
      priceEnd: 20,
    },
    {
      name: props.t("Below 10"),
      option: "below10",
      priceStart: 0,
      priceEnd: 10,
    },
  ]

  const genderData = [
    {
      name: props.t("Male"),
      option: "Male",
    },
    {
      name: props.t("Female"),
      option: "Female",
    },
  ]

  const ageData = [
    {
      name: props.t("Age Below 50"),
      option: 50,
    },
    {
      name: props.t("Age Below 40"),
      option: 40,
    },
    {
      name: props.t("Age Below 30"),
      option: 30,
    },
    {
      name: props.t("Age Below 20"),
      option: 20,
    },
  ]

  const [modal_filter, setmodal_filter] = useState(false)
  const [modal_sort, setmodal_sort] = useState(false)

  function tog_filter() {
    setmodal_filter(!modal_filter)
    removeBodyCss()
  }

  function tog_sort() {
    setmodal_sort(!modal_sort)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [col2, setcol2] = useState(false)
  const [col3, setcol3] = useState(false)
  const [col4, setcol4] = useState(false)
  const [col5, setcol5] = useState(false)
  const [col6, setcol6] = useState(false)
  const [col7, setcol7] = useState(false)

  function t_col2() {
    setcol2(!col2)
  }

  function t_col3() {
    setcol3(!col3)
  }

  function t_col4() {
    setcol4(!col4)
  }

  function t_col5() {
    setcol5(!col5)
  }

  function t_col6() {
    setcol6(!col6)
  }

  function t_col7() {
    setcol7(!col7)
  }

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [tableData, setTableData] = useState(null)
  const [listType, setListType] = useState("list_product")
  const [sortType, setSortType] = useState("ASC")
  const [brandFilter, setBrandFilter] = useState([])
  const [categoryFilter, setCategoryFilter] = useState([])
  const [priceStart, setPriceStart] = useState(-1)
  const [priceEnd, setPriceEnd] = useState(-1)
  const [priceFilter, setPriceFilter] = useState(null)
  const [promoFilter, setPromoFilter] = useState(false)
  const [recommendedFilter, setRecommendedFilter] = useState(false)
  const [currency, setCurrency] = useState("")
  const [country, setCountry] = useState("")
  const [genderFilter, setGenderFilter] = useState(null)
  const [ageFilter, setAgeFilter] = useState(-1)
  const [intentionFilter, setIntentionFilter] = useState(null)
  const [interestFilter, setInterestFilter] = useState(null)

  const [language, setLanguage] = useState("eng")

  function resetSortAndFilter() {
    setSortType("ASC")
    setPriceStart(-1)
    setPriceEnd(-1)
    setPriceFilter(null)
    setPromoFilter(false)
    setRecommendedFilter(false)
    if (query.get("type") == "list_category") {
      setBrandFilter([])
    } else {
      setCategoryFilter([])
    }
    setGenderFilter(null)
    setAgeFilter(-1)
    setIntentionFilter(null)
    setInterestFilter(null)
  }

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (query.get("type") == "list_category") {
      setCategoryFilter([...categoryFilter, query.get("id")])
    }

    if (query.get("type") == "list_brand") {
      setBrandFilter([...brandFilter, query.get("id")])
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }

    if (localStorage.getItem("country")) {
      setCountry(localStorage.getItem("country"))
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token && country) {
      getList()
      console.log("use effect")
    }
  }, [
    token,
    sortType,
    priceFilter,
    promoFilter,
    recommendedFilter,
    brandFilter,
    categoryFilter,
    country,
    genderFilter,
    ageFilter,
    intentionFilter,
    interestFilter,
  ])

  const getList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", listType)
    urlencoded.append("member_id", uid)
    urlencoded.append("order_by", sortType)
    urlencoded.append("filter_by_country_id", country)
    brandFilter.forEach((element, index) => {
      urlencoded.append("filter_by_brands_id[" + index + "]", element)
    })
    categoryFilter.forEach((element, index) => {
      urlencoded.append("filter_by_categories_id[" + index + "]", element)
    })
    if (priceFilter != null) {
      urlencoded.append("filter_by_price_start", priceStart)
      urlencoded.append("filter_by_price_end", priceEnd)
    }
    if (recommendedFilter)
      urlencoded.append("filter_by_recommended", recommendedFilter)
    if (promoFilter) urlencoded.append("filter_by_promo", promoFilter)
    if (genderFilter) urlencoded.append("filter_by_gender", genderFilter)
    if (ageFilter > 0) urlencoded.append("filter_by_age", ageFilter)
    if (interestFilter) urlencoded.append("filter_by_interest", interestFilter)
    if (intentionFilter)
      urlencoded.append("filter_by_gift_intention", intentionFilter)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setTableData(postresponse.table)
      getIntentionList()
      getInterestList()
      getFilterList()
    } else {
      // seterror_alert(true)
    }
  }

  const [intentionData, setIntentionData] = useState(null)
  const getIntentionList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_gift_intention")
    urlencoded.append("member_id", uid)
    // urlencoded.append("filter_by_country_id", country)
    // urlencoded.append("option", "get_api_token")
    // urlencoded.append("source", "web")
    // urlencoded.append("api_key", "UgiftZi)$rnK}K%I8PZKey")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request intention", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setIntentionData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [interestData, setInterestData] = useState(null)
  const getInterestList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_interest")
    urlencoded.append("member_id", uid)
    // urlencoded.append("filter_by_country_id", country)
    // urlencoded.append("option", "get_api_token")
    // urlencoded.append("source", "web")
    // urlencoded.append("api_key", "UgiftZi)$rnK}K%I8PZKey")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request interest", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setInterestData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [filterData, setFilterData] = useState(null)
  const getFilterList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append(
      "option",
      query.get("type") == "list_category" ? "list_brand" : "list_category"
    )
    urlencoded.append("order_by", "ASC")
    {
      query.get("type") == "list_category" &&
        brandFilter.forEach((element, index) => {
          urlencoded.append("filter_by_brands_id[" + index + "]", element)
        })
    }
    {
      query.get("type") == "list_brand" &&
        categoryFilter.forEach((element, index) => {
          urlencoded.append("filter_by_categories_id[" + index + "]", element)
        })
    }
    urlencoded.append("filter_by_country_id", country)
    // urlencoded.append("option", "get_api_token")
    // urlencoded.append("source", "web")
    // urlencoded.append("api_key", "UgiftZi)$rnK}K%I8PZKey")

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request filter", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_POST_GET_CATEGORY,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setFilterData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  function updateFilter(e) {
    if (query.get("type") == "list_category") {
      if (e.target.checked) {
        setBrandFilter([...brandFilter, e.target.name])
      } else {
        setBrandFilter(
          brandFilter.filter(value => {
            return value != e.target.name
          })
        )
      }
    } else {
      if (e.target.checked) {
        setCategoryFilter([...categoryFilter, e.target.name])
      } else {
        setCategoryFilter(
          categoryFilter.filter(value => {
            return value != e.target.name
          })
        )
      }
    }
  }

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  backgroundColor: "#F5F5F5",
                  paddingTop: "60px",
                  // paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {/* {productData && productData.} */}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0"></Col>
                    </Row>
                    <Row className="px-3">
                      <Col xs="auto px-0">
                        <button className="btn btn-link">
                          <img
                            src={logofilter}
                            alt=""
                            style={{
                              // position: "absolute",
                              // objectFit: "contain",
                              maxHeight: "24px",
                            }}
                            onClick={tog_filter}
                          />
                        </button>
                      </Col>
                      <Col xs="auto ps-0 px-0">
                        <button className="btn btn-link px-0">
                          <img
                            src={logosort}
                            alt=""
                            style={{
                              // position: "absolute",
                              // objectFit: "contain",
                              maxHeight: "24px",
                            }}
                            onClick={tog_sort}
                          />
                        </button>
                      </Col>
                      <Col className="font-size-14 text-end align-self-center">
                        <button
                          className="btn btn-link px-0"
                          onClick={() => {
                            resetSortAndFilter()
                          }}
                        >
                          {props.t("Reset")}
                        </button>
                      </Col>
                    </Row>
                    {tableData &&
                      tableData.map((productData, index) => (
                        <Row
                          className="g-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <Col
                            className="px-3 mb-0"
                            onClick={() => {
                              history.push(
                                "/product-details?id=" + productData.id
                              )
                            }}
                          >
                            {/* <Link to={"/product-details?id=" + productData.id}> */}
                            <Card
                              className="py-3 mb-0 shadow-none"
                              key={`productData-${index}`}
                              style={{
                                borderRadius: "0",
                                borderBottom: "1px",
                                borderBottomColor: "#D6D6D6",
                                borderBottomStyle: "solid",
                              }}
                            >
                              <Row>
                                <Col xs="auto">
                                  <img
                                    src={productData.image}
                                    className="avatar-lg"
                                    alt=""
                                    style={{
                                      borderRadius: "8px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <Row>
                                    <Col>
                                      <strong>
                                        <span
                                          className="font-size-15 text-dark"
                                          style={{ fontWeight: 700 }}
                                        >
                                          {
                                            multiLanguageHandler(
                                              productData.multiple_languages
                                            ).name
                                          }
                                        </span>
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col xs="auto">
                                      <span className="font-size-15 text-dark">
                                        {productData.campaign_info &&
                                          (productData.campaign_info
                                            .discount_mode
                                            ? currency +
                                              " " +
                                              productData.campaign_info
                                                .discounted_price
                                            : currency +
                                              " " +
                                              productData.discounted_price)}
                                      </span>
                                    </Col>
                                    {productData.discounted_price !=
                                      productData.original_price && (
                                      <Col xs="auto">
                                        <span className="font-size-15 text-muted">
                                          <s>
                                            {currency +
                                              " " +
                                              productData.original_price}
                                          </s>
                                        </span>
                                      </Col>
                                    )}
                                  </Row>
                                  {productData.campaign_info &&
                                    (productData.campaign_info.discount_mode ? (
                                      <Row className="mt-3">
                                        <Col>
                                          <i className="bx bxs-discount align-middle font-size-20 text-danger me-2" />
                                          <span className="font-size-15 text-dark align-middle">
                                            {productData.campaign_info &&
                                              productData.campaign_info
                                                .discount_message}
                                          </span>
                                        </Col>
                                      </Row>
                                    ) : null)}
                                </Col>
                              </Row>
                            </Card>
                            {/* </Link> */}
                          </Col>
                        </Row>
                      ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_filter}
        toggle={() => {
          tog_filter()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Filter")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_filter(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Card
            className="py-4 mb-0 shadow-none"
            style={{
              borderRadius: "0",
              borderBottom: "1px",
              borderBottomColor: "#D6D6D6",
              borderBottomStyle: "solid",
            }}
          >
            <Row>
              <Col xs="auto">
                <img
                  src={filterPromo}
                  // className="avatar-lg"
                  alt=""
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <span
                      className="font-size-15 "
                      style={{ color: "#4A4A4A" }}
                    >
                      {props.t("Promo")}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col xs="auto">
                <Row>
                  <Col>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="promoFilterCheckBox"
                      checked={promoFilter}
                      onChange={() => {
                        setPromoFilter(!promoFilter)
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <Card
            className="py-4 mb-0 shadow-none"
            style={{
              borderRadius: "0",
              borderBottom: "1px",
              borderBottomColor: "#D6D6D6",
              borderBottomStyle: "solid",
            }}
          >
            <Row>
              <Col xs="auto">
                <img
                  src={filterRecommeded}
                  // className="avatar-lg"
                  alt=""
                />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <span
                      className="font-size-15 "
                      style={{ color: "#4A4A4A" }}
                    >
                      {props.t("Recommended")}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col xs="auto">
                <Row>
                  <Col>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="recommendedFilterCheckbox"
                      checked={recommendedFilter}
                      onChange={() => {
                        setRecommendedFilter(!recommendedFilter)
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
          <div className="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col2}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={filterPrice}
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {props.t("Price")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col2} className="accordion-collapse">
                <div className="accordion-body p-0">
                  {priceFilterData.map((data, index) => (
                    <Row className="py-3">
                      <Col>
                        <Row>
                          <Col>
                            <span
                              className="font-size-15 "
                              style={
                                sortType == data.option
                                  ? { color: "#4A4A4A", fontWeight: 700 }
                                  : { color: "#4A4A4A" }
                              }
                            >
                              {data.name}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs="auto">
                        <Row>
                          <Col>
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios1"
                              value={data.option}
                              checked={priceFilter == data.option}
                              onChange={() => {
                                setPriceFilter(data.option)
                                setPriceStart(data.priceStart)
                                setPriceEnd(data.priceEnd)
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  {/* <Row>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {"Filter type"}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs="auto">
                      <Row>
                        <Col>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customCheckcolor1"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                </div>
              </Collapse>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col3}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={
                          query.get("type") == "list_category"
                            ? filterBrands
                            : filterCategories
                        }
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {query.get("type") == "list_category"
                              ? props.t("Brands")
                              : props.t("Categories")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col3} className="accordion-collapse">
                <div className="accordion-body px-0">
                  {filterData &&
                    filterData.map((data, index) => (
                      <div>
                        <Row>
                          <Col xs="auto">
                            <img
                              src={data.image}
                              className="avatar-xs"
                              alt=""
                              style={{
                                maxWidth: "24px",
                                maxHeight: "24px",
                              }}
                            />
                          </Col>
                          <Col>
                            <Row>
                              <Col>
                                <span
                                  className="font-size-15 "
                                  style={{ color: "#4A4A4A" }}
                                >
                                  {data.name}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs="auto">
                            <Row>
                              <Col>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="filterCheckBox"
                                  name={data.id}
                                  checked={
                                    query.get("type") == "list_category"
                                      ? brandFilter.includes(data.id)
                                      : categoryFilter.includes(data.id)
                                  }
                                  onChange={updateFilter}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <hr
                          style={{
                            color: "#EAEAEA",
                            backgroundColor: "#EAEAEA",
                            height: "2px",
                          }}
                        />
                      </div>
                    ))}
                </div>
              </Collapse>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col4}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={filterRecommeded}
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {props.t("Age")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col4} className="accordion-collapse">
                <div className="accordion-body px-0 pt-0">
                  {ageData.map((data, index) => (
                    <Card
                      className="py-4 mb-0 shadow-none"
                      style={{
                        borderRadius: "0",
                        borderBottom: "1px",
                        borderBottomColor: "#D6D6D6",
                        borderBottomStyle: "solid",
                      }}
                    >
                      <Row>
                        <Col>
                          <Row>
                            <Col>
                              <span
                                className="font-size-15 "
                                style={
                                  ageFilter == data.option
                                    ? { color: "#4A4A4A", fontWeight: 700 }
                                    : { color: "#4A4A4A" }
                                }
                              >
                                {data.name}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs="auto">
                          <Row>
                            <Col>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="ageRadios"
                                id={"ageRadios" + index}
                                value={data.option}
                                checked={ageFilter == data.option}
                                onChange={() => {
                                  setAgeFilter(data.option)
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                </div>
              </Collapse>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col5}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={filterRecommeded}
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {props.t("Gender")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col5} className="accordion-collapse">
                <div className="accordion-body px-0 pt-0">
                  {genderData.map((data, index) => (
                    <Card
                      className="py-4 mb-0 shadow-none"
                      style={{
                        borderRadius: "0",
                        borderBottom: "1px",
                        borderBottomColor: "#D6D6D6",
                        borderBottomStyle: "solid",
                      }}
                    >
                      <Row>
                        <Col>
                          <Row>
                            <Col>
                              <span
                                className="font-size-15 "
                                style={
                                  genderFilter == data.option
                                    ? { color: "#4A4A4A", fontWeight: 700 }
                                    : { color: "#4A4A4A" }
                                }
                              >
                                {data.name}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                        <Col xs="auto">
                          <Row>
                            <Col>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="genderRadios"
                                id={"genderRadios" + index}
                                value={data.option}
                                checked={genderFilter == data.option}
                                onChange={() => {
                                  setGenderFilter(data.option)
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                </div>
              </Collapse>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col6}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={filterRecommeded}
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {props.t("Interest")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col6} className="accordion-collapse">
                <div className="accordion-body px-0 pt-0">
                  {interestData &&
                    interestData.map((data, index) => (
                      <Card
                        className="py-4 mb-0 shadow-none"
                        style={{
                          borderRadius: "0",
                          borderBottom: "1px",
                          borderBottomColor: "#D6D6D6",
                          borderBottomStyle: "solid",
                        }}
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <span
                                  className="font-size-15 "
                                  style={
                                    interestFilter == data.cf_content_value
                                      ? { color: "#4A4A4A", fontWeight: 700 }
                                      : { color: "#4A4A4A" }
                                  }
                                >
                                  {data.cf_content_label}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs="auto">
                            <Row>
                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="interestRadios"
                                  id={"interestRadios" + index}
                                  value={data.cf_content_value}
                                  checked={
                                    interestFilter == data.cf_content_value
                                  }
                                  onChange={() => {
                                    setInterestFilter(data.cf_content_value)
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                </div>
              </Collapse>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button
                  className="accordion-button fw-medium collapsed px-0 py-4"
                  type="button"
                  onClick={t_col7}
                  style={{ cursor: "pointer" }}
                >
                  <Row>
                    <Col xs="auto">
                      <img
                        src={filterRecommeded}
                        // className="avatar-lg"
                        alt=""
                      />
                    </Col>
                    <Col>
                      <Row>
                        <Col>
                          <span
                            className="font-size-15 "
                            style={{ color: "#4A4A4A" }}
                          >
                            {props.t("Gift Intention")}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </button>
              </h2>

              <Collapse isOpen={col7} className="accordion-collapse">
                <div className="accordion-body px-0 pt-0">
                  {intentionData &&
                    intentionData.map((data, index) => (
                      <Card
                        className="py-4 mb-0 shadow-none"
                        style={{
                          borderRadius: "0",
                          borderBottom: "1px",
                          borderBottomColor: "#D6D6D6",
                          borderBottomStyle: "solid",
                        }}
                      >
                        <Row>
                          <Col>
                            <Row>
                              <Col>
                                <span
                                  className="font-size-15 "
                                  style={
                                    intentionFilter == data.cf_content_value
                                      ? { color: "#4A4A4A", fontWeight: 700 }
                                      : { color: "#4A4A4A" }
                                  }
                                >
                                  {data.cf_content_label}
                                </span>
                              </Col>
                            </Row>
                          </Col>
                          <Col xs="auto">
                            <Row>
                              <Col>
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="interestRadios"
                                  id={"interestRadios" + index}
                                  value={data.cf_content_value}
                                  checked={
                                    intentionFilter == data.cf_content_value
                                  }
                                  onChange={() => {
                                    setIntentionFilter(data.cf_content_value)
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                </div>
              </Collapse>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_filter()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modal_sort}
        toggle={() => {
          tog_sort()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Sort")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_sort(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {sortData.map((data, index) => (
            <Card
              className="py-4 mb-0 shadow-none"
              style={{
                borderRadius: "0",
                borderBottom: "1px",
                borderBottomColor: "#D6D6D6",
                borderBottomStyle: "solid",
              }}
            >
              <Row>
                <Col xs="auto">
                  <img
                    // src={"https://dummyimage.com/21x21/000/fff"}
                    src={data.icon}
                    // className="avatar-lg"
                    alt=""
                  />
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <span
                        className="font-size-15 "
                        style={
                          sortType == data.option
                            ? { color: "#4A4A4A", fontWeight: 700 }
                            : { color: "#4A4A4A" }
                        }
                      >
                        {data.name}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col xs="auto">
                  <Row>
                    <Col>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="exampleRadios"
                        id="exampleRadios1"
                        value={data.option}
                        checked={sortType == data.option}
                        onChange={() => {
                          setSortType(data.option)
                          tog_sort()
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          ))}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_sort()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Products)

Products.propTypes = {
  t: PropTypes.any,
}
